import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

export default function SaleCompSorting({ sort, onChange }) {
  return (
    <ManagedInput
      className="form-select w-auto"
      type="select"
      value={sort}
      onValueChange={onChange}
    >
      <option value="distance asc">Distance</option>
      <option value="updated_at desc">Last Modified (Desc)</option>
      <option value="updated_at asc">Last Modified (Asc)</option>
      <option value="created_at desc">Date Created (Desc)</option>
      <option value="created_at asc">Date Created (Asc)</option>
      <option value="price desc">Sale Price (Desc)</option>
      <option value="price asc">Sale Price (Asc)</option>
      <option value="cap_rate_pct desc">Cap Rate (Desc)</option>
      <option value="cap_rate_pct asc">Cap Rate (Asc)</option>
    </ManagedInput>
  );
}

SaleCompSorting.propTypes = {
  sort: PropTypes.string,
  onChange: PropTypes.func,
};
